import React from "react"
import { makeStyles, Typography, Divider } from "@material-ui/core"
import { MyContainer } from "./container"
import { AMd } from "./mdComponents/aMd"

const useStyles = makeStyles((theme) => ({
    root: {
        marginTop: theme.spacing(6),
    },
    footer: {
        paddingTop: theme.spacing(8),
        paddingBottom: theme.spacing(8),
    },
    text: {
        color: theme.palette.grey[500],
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
    },
    nobr: {
        whiteSpace: 'nowrap',
    }
}))

const entries = [
    `© Copyright ${new Date().getFullYear()}`,
    "Business Trainer Österreich",
    "All Rights Reserved",
    {type: 'a', name: 'Impressum', link: '/impressum'},
    {type: 'a', name: 'Datenschutzerklärung', link: '/data-processing-agreement'},
];

export const Footer = () => {
    const classes = useStyles()

    return <div className={classes.root}>
        <Divider/>
        <MyContainer>
            <footer className={classes.footer}>
                <Typography className={classes.text} variant={"caption"}>
                    {entries.map((e, i) => {
                        const key = `e${i}`;
                        if(typeof e === 'string') {
                            return <span key={key} className={classes.nobr}>{e}</span>;
                        }
                        if(e.type === 'a') {
                            return <AMd key={key} href={e.link} inverted>{e.name}</AMd>;
                        }
                        return null;
                    }).map((e, i) => i < entries.length - 1 ? [e, <span key={`s${i}`}>&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;</span>] : [e]).reduce((a,b) => a.concat(b))}
                </Typography>
            </footer>
        </MyContainer>
    </div>
}